import type { RootState } from '@reducers/index';
import classnames from 'classnames';
import dynamic from 'next/dynamic';
import React from 'react';
import { connect } from 'react-redux';
import { OrderSelector } from '../Filters/OrderSelector';
import ownClasses from './top-bar.module.scss';
import type { SearchState } from '@reducers/search';
import type { FiltersConfigState } from '@reducers/filtersConfig';

interface StateProps {
  noOfAds: number;
  search: SearchState;
  filtersConfig: FiltersConfigState;
}

const SavedSearchButton = dynamic(() => import('../SavedSearchButton'));

export const TopBarComponent: React.FC<StateProps> = (props) => {
  return (
    <div
      className={classnames('top-bar', ownClasses['top-bar'], {
        [ownClasses['no-ads']]: props.noOfAds == 0,
      })}
    >
      <SavedSearchButton
        search={props.search}
        filtersConfig={props.filtersConfig}
      />
      <OrderSelector />
    </div>
  );
};

TopBarComponent.displayName = 'TopBar';

export default connect<StateProps, never, unknown, RootState>((state) => ({
  search: state.search,
  noOfAds: state.items.total,
  filtersConfig: state.filtersConfig,
}))(TopBarComponent);
